import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {Box} from "@mui/material";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";

const CustomDialogTitle = ({
  onClose = null,
  id = undefined,
  className = "",
  rightActions = null,
  icon = null,
  children,
  ...props
}) => {
  const {t} = useTranslation();

  return (
    <Box
      className={`MuiDialogTitle-root components__dialog__header ${className}`}
      sx={{
        padding: "16px 24px"
      }}
      {...props}
    >
      <Grid container justifyContent="space-between" alignItems="flex-start" wrap="nowrap" columnSpacing={"8px"}>
        <Grid
          className="components__dialog__icon-and-title"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px"
          }}
        >
          {icon && (
            <Grid className="components__dialog__icon" sx={{display: "flex"}}>
              {icon}
            </Grid>
          )}
          <Grid className="components__dialog__title">
            {children ? (
              typeof children === "string" ? (
                <Typography id={id} variant="h6" sx={{display: "inline"}}>
                  {children}
                </Typography>
              ) : (
                children
              )
            ) : null}
          </Grid>
        </Grid>
        <Grid className="components__dialog__actions">
          <Grid container alignItems="center" wrap="nowrap" columnSpacing={"4px"}>
            {rightActions && (
              <Grid className="components__dialog__action components__dialog__action--custom">{rightActions}</Grid>
            )}
            {onClose && (
              <Grid className="components__dialog__action components__dialog__action--close">
                <IconButton
                  aria-label={t("components.customDialogTitle.close.ariaLabel")}
                  sx={{
                    marginRight: "-8px",
                    padding: "4px"
                  }}
                  onClick={onClose}
                >
                  <CloseIcon />
                </IconButton>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CustomDialogTitle;
